// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editbutton2{margin:5px;background-color:var(--button-color);color:#fff;border:none;padding:5px}", ""]);
// Exports
module.exports = exports;
